import { defineComponent, PropType, toRef, Ref, watch } from 'vue';
import Suggestion from './Suggestion.class';
import { Suggestion as SuggestionDTO } from '@/interfaces/suggestion.interface';
import { setupComponent } from '@studyportals/vue-platform';


export default defineComponent({
	props: {
		index: {
			type: Number,
			default: 0,
		},
		suggestion: {
			type: Object as PropType<SuggestionDTO>,
			required: true
		},
	},
	setup: (props) => {
		const suggestionRef: Ref<SuggestionDTO> = toRef(props, 'suggestion');
		const indexRef: Ref<number> = toRef(props, 'index');
		const suggestion = new Suggestion(suggestionRef,indexRef);
		watch(suggestion.keyboardEvent, suggestion.onKeyDownChange.bind(suggestion));

		return setupComponent(suggestion);
	}
});
